import { observer } from "mobx-react-lite";
import { ReactNode } from "react";

import SaveButton from "./SaveButton";
import { useIsReadonly } from "./readonly-context";

import { BlockProps } from ".";

interface BlockFooterProps {
  onSave?: BlockProps["onSave"];
  requireValidation?: boolean;
  children?: ReactNode;
}

const BlockFooter = observer(({ onSave, requireValidation = true, children }: BlockFooterProps) => {
  const isReadonly = useIsReadonly();

  if (isReadonly) {
    return null;
  }

  return (
    <div className="flex flex-col gap-y-3">
      {children}
      <SaveButton onSave={onSave} requireValidation={requireValidation} />
    </div>
  );
});

export default BlockFooter;
